import type { ThemeMode } from '@/stores/theme'

export type UrlColorModeParam = ThemeMode | 'system'

function queryModeString(mode: unknown): string | undefined {
  if (typeof mode === 'string') return mode
  if (Array.isArray(mode) && typeof mode[0] === 'string') return mode[0]
  return undefined
}

/**
 * Updates the `mode` query param (light | dark | system) without a full page reload.
 * Uses dynamic import of the router to avoid a static import cycle with iframeCommunication.
 */
export async function syncColorModeToUrl(mode: UrlColorModeParam): Promise<void> {
  const { default: router } = await import('@/router')
  const r = router.currentRoute.value
  if (queryModeString(r.query.mode) === mode) return
  await router.replace({
    path: r.path,
    query: { ...r.query, mode },
    hash: r.hash,
  })
}
